import { FETCH_REQUEST } from '../../sharedTypes';
import { GET_PROFILE_ADMIN } from '../../fetchTypes';

export const profileRequest = data => ({
  type: FETCH_REQUEST,
  fetchType: GET_PROFILE_ADMIN,
  data,
});
